/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import React, { useState, useContext, useRef, useEffect } from 'react';
import validate from 'validate.js'
import { IndexContext } from '../IndexProvider';
import PAGES from '../consts/pages';

const passwordConstraints = {
    password: {
        presence: {
            allowEmpty: false
        }
    }
};

const confirmedPasswordConstraints = {
    confirmedPassword: {
        presence: {
            allowEmpty: false
        }
    }
};

export default function ChangeTempPassword() {

    const [password, setPassword] = useState("")
    const [confirmedPassword, setConfirmedPassword] = useState("");

    const [isPasswordValid, setIsPasswordValid] = useState(false)
    const [isConfirmedPasswordValid, setIsConfirmedPasswordValid] = useState(false)

    const [shouldShowPasswordFeedback, setShouldShowPasswordFeedback] = useState(false)
    const [shouldShowConfirmedPasswordFeedback, setShouldShowConfirmedPasswordFeedback] = useState(false)

    const [isPending, setIsPending] = useState(false)
    const [isReadOnly, setIsReadOnly] = useState(true)

    useEffect(() => {
        if (password !== confirmedPassword || validate({ confirmedPassword: confirmedPassword }, confirmedPasswordConstraints)) {
            setIsConfirmedPasswordValid(false)
        } else {
            setIsConfirmedPasswordValid(true)
        }
    }, [confirmedPassword])

    const { setCurrentPage, completeNewPasswordChallenge, setMessage } = useContext(IndexContext)

    const onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        let count = 0

        if (validate({ password: password }, passwordConstraints)) {
            setIsPasswordValid(false)
        } else {
            setIsPasswordValid(true)
            count++
        }

        if (validate({ confirmedPassword: password }, confirmedPasswordConstraints)) {
            setIsConfirmedPasswordValid(false)
        } else {
            setIsConfirmedPasswordValid(true)
            count++
        }

        if (count === 2) {
            setIsPending(true)
            await completeNewPasswordChallenge(password)
            setIsPending(false)

        }
    };

    const onPasswordChange = (event) => {
        setPassword(event.target.value)
        setShouldShowPasswordFeedback(true)
        if (validate({ password: event.target.value }, passwordConstraints)) {
            setIsPasswordValid(false)
        } else {
            setIsPasswordValid(true)
        }
    }

    const onConfirmedPasswordChange = (event) => {
        setConfirmedPassword(event.target.value)
        setShouldShowConfirmedPasswordFeedback(true)
    }

    const buildFormControlClasses = (shouldShowFeedback, isValid) => {
        if (shouldShowFeedback) {
            return `form-control ${isValid ? "is-valid" : "is-invalid"}`
        } else {
            return "form-control"
        }
    }

    return (
        <div className="d-flex justify-content-center align-items-center ps-3 pe-3 pt-5 pb-5">
            <form noValidate className="w-100 form-container p-3" style={{ border: "1px solid #0073e6" }} onSubmit={onSubmit} >
                <div className="mb-3 d-flex justify-content-center align-items-center" style={{ backgroundColor: "#0073e6", fontSize: 24, fontWeight: "bold", color: "#fff" }}>
                    <label style={{ marginBottom: 0 }}>初期パスワード変更</label>
                </div>

                <div className="mb-3" >
                    <label htmlFor="passwordInput">新パスワード</label>
                    <input className={buildFormControlClasses(shouldShowPasswordFeedback, isPasswordValid)} onChange={onPasswordChange} value={password} type="password" id="passwordInput" required />
                    <div className="invalid-feedback">
                        新パスワードを入力してください。
                    </div>
                </div>

                <div className="mb-3">
                    <label htmlFor="confirmPasswordInput">新パスワード（確認）</label>
                    <input className={buildFormControlClasses(shouldShowConfirmedPasswordFeedback, isConfirmedPasswordValid)} onChange={onConfirmedPasswordChange} value={confirmedPassword} type="password" id="confirmPasswordInput" required />
                    <div className="invalid-feedback" >
                        入力されたパスワードが一致しません。
                    </div>
                </div>

                <div className="d-flex align-items-start justify-content-between" >
                    <button className="btn btn-primary" type="submit" >
                        {isPending ? "変更中..." : "変更"}
                    </button>
                </div>
            </form>
        </div>
    );
}
